import React, { useContext, useState } from 'react';
import { CartContext } from '../context/CartContext';
import ProductDetails from './ProductDetails';
import { formatAmount, hideIfNA } from '../utils/formatUtils';
import './ProductRow.css'; // Updated CSS import

const ProductRow = ({ product, vendorName, logoUrl, vendorId, orderType }) => {
  const { addToCart } = useContext(CartContext);
  const [showDetails, setShowDetails] = useState(false);

  const handleDetailsOpen = () => setShowDetails(true);
  const handleDetailsClose = () => setShowDetails(false);

  // Early return after hooks are called
  if (!product.image || product.image === '/placeholder-image.png') {
    return null;
  }
  
  // Safeguard values
  const price = product.price ?? 0;
  const salePrice = product.salePrice ?? null;
  const strain = hideIfNA(product.strain);
  const image = product.image || '/placeholder-image.png';
  const amount = formatAmount(product.amount);
  
  // Get tag to display - prioritize 'Staff Pick' if present
  const displayTag = product.tags?.includes('Staff Pick') 
    ? 'Staff Pick' 
    : product.tags?.[0];

  return (
    <>
      <div className="pr-row">
        {/* Product Image */}
        <div className="pr-image-col" onClick={handleDetailsOpen}>
          {/* Sale Badge */}
          {salePrice && (
            <span className="pr-sale-badge">
              SALE
            </span>
          )}
          
          {/* Tag Badge - Now positioned at bottom left */}
          {displayTag && (
            <span className={`pr-tag-badge ${displayTag === 'Staff Pick' ? 'pr-staff-pick' : 'pr-other-tag'}`}>
              {displayTag}
            </span>
          )}

          <img
            src={image}
            alt={product.name || 'Product Image'}
            className="pr-product-image"
          />
        </div>

        {/* Product Info */}
        <div className="pr-info-col">
          {/* Brand and Amount Row */}
          <div className="pr-brand-row">
            {/* Product Brand */}
            <p className="pr-brand-text" onClick={handleDetailsOpen}>
              {product.brand || 'No Brand'}
            </p>

            {/* Amount Badge - Only show if amount exists */}
            {amount && (
              <span className="pr-amount-badge">
                {amount}
              </span>
            )}
          </div>

          {/* Product Name */}
          <p className="pr-product-name" onClick={handleDetailsOpen}>
            {product.name}
          </p>

          {/* Product Strain - Only show if strain exists */}
          {strain && (
            <p className="pr-strain-text" onClick={handleDetailsOpen}>
              {strain}
            </p>
          )}

          {/* Price Section */}
          <div className="pr-price-container">
            {/* Sale Price or Regular Price */}
            {salePrice ? (
              <>
                <span className="pr-sale-price">
                  ${salePrice.toFixed(2)}
                </span>
                <span className="pr-original-price">
                  ${price.toFixed(2)}
                </span>
              </>
            ) : (
              <span className="pr-regular-price">
                ${price.toFixed(2)}
              </span>
            )}
          </div>
        </div>

        {/* Add to Cart Button */}
        <div className="pr-button-col">
          <button
            className="pr-add-button"
            onClick={(e) => {
              e.stopPropagation();
              addToCart({
                ...product,
                price: price,
                salePrice: salePrice,
                vendorName,
                logoUrl,
                primaryImage: image,
                strain: strain,
                vendorId,
                productId: product._id,
                orderType,
              });
            }}
          >
            +
          </button>
        </div>
      </div>

      {/* Product Details Modal */}
      <ProductDetails
        show={showDetails}
        handleClose={handleDetailsClose}
        product={product}
        vendorName={vendorName}
        logoUrl={logoUrl}
        vendorId={vendorId}
      />
    </>
  );
};

export default ProductRow;